import React, {
    useState,
    useCallback,
    useImperativeHandle,
    forwardRef,
} from "react";
import debounce from "src/utils/debounce";
import styles from "./styles.module.scss";
import moment from "moment-timezone";

const CustomDateRangeFilter = forwardRef((props, ref) => {
    const [range, setRange] = useState({
        dateFrom: null,
        dateTo: null,
    });

    // Debounced function to trigger the filter change callback
    const onRangeChangeDebounced = useCallback(
        debounce(async (newRange) => {
            props.filterChangedCallback();
        }, 500),
        []
    );

    const onRangeChange = (event) => {
        const {
            value,
            dataset: { field },
        } = event.target;
        const newRange = {
            ...range,
            [field]: value || null,
        };
        setRange(newRange);
        onRangeChangeDebounced(newRange);
    };

    useImperativeHandle(ref, () => ({
        getModel() {
            if (range.dateFrom && !range.dateTo) {
                return {
                    dateFrom: moment(range.dateFrom).format(
                        "YYYY-MM-DD HH:mm:ss"
                    ),
                    dateTo: range.dateTo,
                    filterType: "date",
                    type: "greaterThanOrEqual",
                };
            } else if (!range.dateFrom && range.dateTo) {
                return {
                    dateFrom: moment(range.dateTo).format(
                        "YYYY-MM-DD HH:mm:ss"
                    ),
                    dateTo: range.dateFrom,
                    filterType: "date",
                    type: "lessThanOrEqual",
                };
            } else if (range.dateFrom && range.dateTo) {
                return {
                    dateFrom: moment(range.dateFrom).format(
                        "YYYY-MM-DD HH:mm:ss"
                    ),
                    dateTo: moment(range.dateTo).format("YYYY-MM-DD HH:mm:ss"),
                    filterType: "date",
                    type: "inRange",
                };
            } else {
                return null;
            }
        },

        setModel(model) {
            setRange({
                dateFrom: model ? new Date(model.dateFrom) : null,
                dateTo: model ? new Date(model.dateTo) : null,
            });
        },

        doesFilterPass(params) {
            const { dateFrom, dateTo } = range;
            const value = params.data[props.colDef.field];
            return (
                (dateFrom === null || new Date(value) >= new Date(dateFrom)) &&
                (dateTo === null || new Date(value) <= new Date(dateTo))
            );
        },
        // this method indicates if the filter is active hence shows AGgrid filter icon
        isFilterActive() {
            return range.dateFrom !== null || range.dateTo !== null;
        },
    }));

    const clearFilter = () => {
        setRange({
            dateFrom: null,
            dateTo: null,
        });
        onRangeChangeDebounced();
    };

    return (
        <div className={styles.customRangeFilter}>
            <label
                style={{
                    marginBottom: "4px",
                }}
            >
                Min
            </label>
            <input
                type="date"
                data-field="dateFrom"
                value={range.dateFrom || ""}
                onChange={onRangeChange}
                placeholder="Min"
            />
            <label
                style={{
                    marginBottom: "4px",
                }}
            >
                Max
            </label>
            <input
                type="date"
                data-field="dateTo"
                value={range.dateTo || ""}
                onChange={onRangeChange}
                placeholder="Max"
            />
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    cursor: "pointer",
                }}
            >
                <button
                    onClick={clearFilter}
                    data-testid="clear-custom-range-filter"
                    style={{
                        cursor: "pointer",
                    }}
                >
                    Clear
                </button>
            </div>
        </div>
    );
});

export default CustomDateRangeFilter;
